import Lock from '@mui/icons-material/Lock';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import React from 'react';
import SiteHeader from './SiteHeader/SiteHeader';

const CantAccessStudy: React.FunctionComponent<React.PropsWithChildren<unknown>> = () => {
  const theme = useTheme();
  return (
    <>
      <SiteHeader />
      <Grid item container justifyContent="center" alignItems="center" sx={{ height: '100%' }}>
        <Box>
          <Lock sx={{ fontSize: 250, color: theme.palette.primary.main, display: 'block', margin: '0 auto' }} />
          <Typography variant="h2" sx={{ textAlign: 'center', display: 'block' }}>
            You currently do not have access to selected study.
          </Typography>
          <Typography variant="subtitle1" sx={{ textAlign: 'center', display: 'block', marginTop: 2 }}>
            Please contact your lab or study administrator.
          </Typography>
        </Box>
      </Grid>
    </>
  );
};

export default CantAccessStudy;
